const REQUEST_ID_HEADER = 'X-Request-ID';
export const normalizeGraphQLError = (error, operation) => {
    var _a, _b;
    const context = (_a = operation === null || operation === void 0 ? void 0 : operation.getContext) === null || _a === void 0 ? void 0 : _a.call(operation);
    const headers = (_b = context === null || context === void 0 ? void 0 : context.response) === null || _b === void 0 ? void 0 : _b.headers;
    const requestId = headers.get(REQUEST_ID_HEADER);
    const details = [];
    if (operation === null || operation === void 0 ? void 0 : operation.operationName) {
        details.push({ label: 'Operation name', value: operation.operationName });
    }
    if (requestId) {
        details.push({ label: 'X-Request-ID', value: requestId });
    }
    if (error === null || error === void 0 ? void 0 : error.message) {
        details.push({ label: 'Error text', value: error.message });
    }
    return { details };
};
